module.exports = __webpack_public_path__ + "media/153.301067bd.mp3";